export const deviceTypesMap = new Map([
    ['NAModule1', 'Outdoor Module'],
    ['NAModule2', 'Anemometer'],
    ['NAModule3', 'Rain Gauge'],
    ['NAModule4', 'Additional Indoor Module'],
    ['NATherm1', 'Thermostat'],
    ['NACamDoorTag', 'Sensor'],
    ['NIS', 'Indoor Siren'],
    ['NACamera', 'Indoor Camera'],
    ['NOC', 'Outdoor Camera'],
    ['NOC2', 'Outdoor Camera Original'],
    ['NOC-S', 'Outdoor Camera with Siren'],
    ['NOC2', 'Outdoor Camera Original'],
    ['NDB', 'Doorbell'],
    ['NAPlug', 'Thermostat'],
    ['NTG', 'Essential Thermostat'],
    ['NAMain', 'Weather Station'],
    ['OTH', 'Modulating Thermostat Relay'],
    ['OTM', 'Modulating Thermostat'],
    ['NDL', 'Door Lock'],
    ['NSD', 'Smoke Alarm'],
    ['NHC', 'Air Quality Monitor'],
    ['NHC-PRO', 'Pro Air Quality Monitor'],
    ['NAThermVaillant', 'Vaillant Thermostat'],
    ['NRV', 'Radiator Valve'],
    ['NLP', 'Outlet'],
    ['NLPM', 'Mobile Socket'],
    ['NLPO', 'Contactor'],
    ['NLPT', 'Teleruptor'],
    ['NLOC', 'Rotary Color Switch'],
    ['NLPC', 'Energy Meter'],
    ['NLM', 'Micromodule'],
    ['NLF', 'Dimmer Light Switch'],
    ['NLL', 'Wire On/Off Switch'],
    ['NLT', 'Remote Switch'],
    ['NLTS', 'Movement Detector'],
    ['NLFN', '3 Wires On/Off Dimmer'],
    ['NLFE', '2 Wires On/Off Dimmer'],
    ['NLD', 'Remote Two Buttons'],
    ['NLV', 'Roller Shutter'],
    ['NLLV', 'Shutter with level'],
    ['NLLF', 'Centralized ventilation control'],
    ['NLC', 'Cable Outlet'],
    ['NLIS', 'Light Switch'],
    ['NLIB', 'Simple Light Switch'],
    ['NLUI', 'In-Wall Switch'],
    ['NLUF', 'In-Wall Dimmer'],
    ['NLUP', 'Plug-In Switch'],
    ['NLUO', 'Plug-In Dimmer'],
    ['NLDD', 'Remote Dimmer'],
    ['NLPS', 'Smart Shedder'],
    ['NLDP', 'Remote 4 Scenes'],
    ['NLAHA', 'Green Power Home Away'],
    ['NLAWS', 'Green Power Wake up Sleep'],
    ['NLAV', 'Green Power Roller shutter'],
    ['NLAO', 'Green Power On/Off'],
    ['NLAS', 'Green Power Scenario'],
    ['LIP', 'Dry Contact'],
    ['NLunknown', 'Unknown'],
    ['Z3L', 'Zigbee Light'],
    ['Z3V', 'Zigbee Rolling Shutter'],
    ['NXD', 'Departure switch'],
    ['NXS', 'Sensor'],
    ['NXO', 'Actuator'],
    ['NXB', 'Beacon'],
    ['NLG', 'Magellan'],
    ['NBG', 'Bubendorff'],
    ['MFH', 'Multi Familly Household'],
    ['Zbx', 'Zenbox'],
    ['TPSG', 'Somfy Tahoma Gateway'],
    ['NAThermVaillant', 'Vaillant Thermostat'],
    ['NCO', 'Carbon Monoxide Detector'],
    ['BNS', 'Smarther'],
    ['NLE', 'Ecometer'],
    ['NAC', 'Air Conditioner Controller'],
    ['BAC', 'SmartherAC'],
    ['NXG', 'Velux Gateway'],
    ['NMG', 'Muller Gateway'],
    ['NMH', 'Heater Muller'],
    ['NMR', 'Router Muller'],
    ['NMT', 'Router Tele-Info Muller'],
    ['NMW', 'Water-Heater Muller'],
    ['BNCX', 'Classe 300EOS'],
    ['ELG', 'Engie - Gateway ERL'],
    ['EBU', 'Capteur Gaz'],
    ['BNDL', 'Doorlock'],
    ['BNSL', 'Staircase Light'],
    ['BNEU', 'External Unit'],
    ['BNIL', 'Intelligent Light'],
    ['BNLD', 'Lighting Dimmer'],
    ['BNAB', 'Automatic Blind'],
    ['BNAS', 'Automatic Shutter'],
    ['BNMS', 'Motorized Shade'],
    ['BNTH', 'Thermostat'],
    ['BNTR', 'Towel Rail'],
    ['BNFC', 'Fan Coil'],
    ['BNCS', 'Controlled Socket'],
    ['BNLO', 'Lock'],
    ['BNXM', 'X Meter'],
    ['BN3L', '3rd Party Lights'],
    ['BNMH', 'MyHOMEServer1'],
    ['NPC', 'Indoor Camera Advance'],
    ['BFII', 'Full IP DES'],
    ['BPVC', 'Phoenix Video'],
    ['BPAC', 'Phoenix Audio'],
    ['BNC1', 'Classe 100X'],
    ['BNC3', 'Classe 300X'],
    ['NLJ', 'Garage Door'],
    ['NLY', 'Three-phase Energy Meter'],
    ['BDIY', 'Easy Kit Connected'],
    ['NLEVSE', 'Electric Vehicle Supply Equipment'],
    ['BNHY', 'F460'],
]);
